module.exports = __webpack_public_path__ + "img/footballBanner_900.8236c605.png";